import ShariffLinkGeneratorFactory from "@/ts/components/Shariff/ShariffLinkGeneratorFactory";
import type ShariffLinkGeneratorInterface from "@/ts/components/Shariff/Interfaces/ShariffLinkGeneratorInterface";
import SocialMediaEnum from "@/ts/components/Shariff/Enums/SocialMediaEnum";

export default class ShariffInjector {
    private window: Window;
    private document: Document;
    private linkGeneratorCache: Map<string, ShariffLinkGeneratorInterface>;

    constructor(
        private generatorFactory: ShariffLinkGeneratorFactory,
        win?: Window,
        doc?: Document
    ) {
        this.window = win ?? window;
        this.document = doc ?? document;
        this.linkGeneratorCache = new Map<string, ShariffLinkGeneratorInterface>();
    }

    public initButtons(url: string): void {
        this.document.querySelectorAll("[data-shariff]").forEach(shariffButton => {
            const type: SocialMediaEnum = shariffButton.getAttribute("data-shariff") as SocialMediaEnum
                ?? SocialMediaEnum.UNDEFINED;
            const linkGenerator = this.generatorFactory
                .linkGeneratorByTypeString(type);
            if (linkGenerator) {
                const link = linkGenerator.generateLink(url);

                shariffButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.window.open(link, "_blank", "width=600, height=400");
                });
                this.linkGeneratorCache.set(type, linkGenerator);
            }
        });
    }
}
